import { memo, useId } from 'react';
import type { PropsWithChildren, ReactNode } from 'react';
import { capitalize } from 'lodash';
import type { TWidget } from 'types/hubDashboard.type';
import { Card, Col, Typography } from '@timeedit/ui-components/antd';
import Widgets from '../Widget';
import './HubWidgetWrapper.scss';

export interface HubWidgetWrapperProps {
  widget: TWidget;
  actions?: ReactNode[];
  id?: string;
}

export const HubWidgetContainer = ({ children }: { children: ReactNode }) => (
  <div className="hub-widget-container">{children}</div>
);

const HubWidgetWrapper = memo(
  ({ id, widget, actions = [] }: PropsWithChildren<HubWidgetWrapperProps>) => {
    const generatedId = useId();
    const cardId = id || `compound-card-${generatedId}`;
    const cardTitleId = `${cardId}-title`;

    const { type, parameters = {} } = widget;

    if (!type) {
      return (
        <Col>
          <Card className="hub-widget-card">
            <div
              style={{ padding: '16px', textAlign: 'center', color: '#999' }}
            >
              Widget type not specified
            </div>
          </Card>
        </Col>
      );
    }

    const { title = type, ...content } = parameters;
    const capitalizedTitle = capitalize(title);

    return (
      <Col aria-labelledby={cardTitleId}>
        <Card
          className="hub-widget-card"
          title={
            <Typography.Title level={4} id={cardTitleId}>
              {capitalizedTitle}
            </Typography.Title>
          }
          extra={actions}
        >
          <div className="hub-widget-card-content">
            {Widgets(
              type as keyof typeof import('../Widget').EWidgetType,
              content
            )}
          </div>
        </Card>
      </Col>
    );
  }
);

export default HubWidgetWrapper;
